import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValgMessageBarComponent } from './valg-message-bar.component';
import { MatIconModule } from '@angular/material/icon';
import { ValgInputModule } from '../input/input.module';
import { TipModule } from '../tip/tip.module';

@NgModule({
  declarations: [ ValgMessageBarComponent ],
  exports: [ ValgMessageBarComponent ],
    imports: [
      CommonModule, MatIconModule, TipModule, ValgInputModule
     ],
})
export class ValgMessageBarModule {}
